import React from "react";
import Layout from "../components/layout"
import CCTV_dome_camera from "../images/CCTV_dome_camera.svg";
import Thief from "../images/thief.jpg";
import Thief2 from "../images/thief2.jpg";

export default () => (
  <Layout>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
    <h2 className="is-size-1">Security</h2>
    </div>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
    <p className="is-size-4">
      We provide security services and equipment for use within residential, commercial, and industrial environments. From security cameras to tracking equipment - we have the infrastructure to help you monitor your resources while taking advantage of newer technologies such as machine learning and object recognition. We can help you ensure your locations are secure with real time surveillance, secure offsite media storage, and customized alerting.
    </p>
    </div>
    <div style={{ alignItems: 'center', justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
      <div style={{ overflow: `hidden` }} className="verycentered" >
        <img style={{ float: `left`, padding: `.25em` }} src={CCTV_dome_camera} width="200" alt="Dome Camera"></img>
        <img style={{ float: `left`, padding: `.25em` }} src={Thief} width="350" alt="Thief"></img>
        <img style={{ float: `left`, padding: `.25em` }} src={Thief2} width="350" alt="Thief2"></img>
      </div>
    </div>
  </Layout>
);
